/*
 * @Descripttion: mutations
 * @Author: juanjuanhui
 * @Date: 2022-02-19 19:14:34
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:28:17
 */
import * as types from "./types";
const mutations = {
  [types.GET_ACCESS_TOKEN](state, payload) {
    state.accessToken = payload;
  },
  [types.SAVE_HEAD_MENU_PATH](state, payload) {
    state.headMenuPath = payload;
  },
  [types.CHANGE_SEARCH_NAME](state, payload) {
    state.searchName = payload;
    console.log(state.searchName);
  },
};
export default mutations;
